import { Observable, observe, Scope } from 'wdc-cube'
import { MonitoramentoRow } from './integracao-monitoramento.types'
import { WaitingScope } from 'src/components/waiting/waiting.scopes'

@Observable
export class HeaderScope extends Scope {}

@Observable
export class IntegracaoMonitoramentoScope extends Scope {
    readonly header = new HeaderScope()

    @observe() waiting?: WaitingScope

    @observe() monitorados = [] as MonitoramentoRow[]
    @observe() docFilterInputRef = '' as string

    onFind = Scope.ASYNC_ACTION
    onNew = Scope.ASYNC_ACTION
    onEdit = Scope.ASYNC_ACTION_NUMBER
    onDelete = Scope.ASYNC_ACTION_NUMBER

    onReprocess = Scope.ASYNC_ACTION_ONE<number>()
    onShowResults = Scope.ASYNC_ACTION_ONE<number>()
}

export default IntegracaoMonitoramentoScope
